import { createContext } from "react";

export const IdentifierMappingContext = createContext({});
